<template>
    <form
        id="visa-payment"
        :action="visaFormUrl"
        method='post'
        @submit.prevent.stop=""
        ref="form"
    >
        <button @click="onSubmit" class="button-mask" v-if="!isLoading"></button>
    </form>
</template>
<script>
import { mapGetters } from 'vuex';

function mounted() {
	this.createVisaSession();
}

async function createVisaSession() {
	this.isLoading = true;
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	const body = {
		channel: 'web',
		commerceCode: process.env.COMMERCE_CODE,
		orderId: this.orderSummaryInfo.id,
	};
	try {
		const { data: response } = await this.$httpJapi.post('payment-transaction/visa/token',
			body,
			{ headers },
		);
		({ sessionKey: this.sessionKey, expirationTime: this.expirationTime } = response);
		this.createScript();
	} catch (err) {
		this.$message({
			message: err.errorMessage,
			type: 'error',
		});
	}
	this.isLoading = false;
}

function visaFormUrl() {
	if (this.orderSummaryInfo) {
		const url = 'payment-transaction/gateway-response?purchaseNumber=';
		return `${this.apiSales}/${url}${this.orderSummaryInfo.id}`;
	}
	return '';
}

function onSubmit() {
	this.$refs.form.children[2].click();
}

function createScript() {
	if (process.browser && process.env.VISA_MERCHAN_ID) {
		const visaForm = document.createElement('script');
		const dataSessionToken = this.sessionKey;
		const dataMerchantId = process.env.VISA_MERCHAN_ID;
		const dataAmount = this.total;
		const dataCurrency = this.currentCurrency;
		const purchaseNumber = this.orderSummaryInfo.id;
		visaForm.setAttribute('src', 'https://static-content.vnforapps.com/v2/js/checkout.js');
		visaForm.setAttribute('data-sessiontoken', dataSessionToken);
		visaForm.setAttribute('data-channel', 'web');
		visaForm.setAttribute('data-merchantid', dataMerchantId);
		visaForm.setAttribute('data-merchantlogo', 'http://localhost:8080/static/img/icons/mi-store-peru.svg');
		visaForm.setAttribute('data-merchantname', 'MI Store');
		visaForm.setAttribute('data-formbuttoncolor', '#FF6600');
		visaForm.setAttribute('data-purchasenumber', purchaseNumber);
		visaForm.setAttribute('data-amount', dataAmount);
		visaForm.setAttribute('data-currency', dataCurrency);
		visaForm.setAttribute('currency', dataCurrency);
		visaForm.setAttribute('data-expirationminutes', 20);
		visaForm.setAttribute('data-timeouturl', 'timeout.html');
		document.getElementById('visa-payment').appendChild(visaForm);
	}
}

function total() {
	const totalAmount = (this.getTotalAmount - this.getClientDiscount) + this.shippingCostAmount;
	return Number(totalAmount.toFixed(2));
}

function data() {
	return {
		apiSales: process.env.API_JAPI,
		expirationTime: null,
		isLoading: false,
		sessionKey: null,
	};
}

export default {
	name: 'visa-net',
	computed: {
		...mapGetters([
			'currentCurrency',
			'getClientDiscount',
			'getTotalAmount',
			'orderSummaryInfo',
			'shippingCostAmount',
			'token',
		]),
		total,
	},
	data,
	methods: {
		createScript,
		createVisaSession,
		onSubmit,
		visaFormUrl,
	},
	mounted,
};
</script>
<style lang="scss" scoped>
	.button-mask {
		background-color: transparent;
		border: none;
		height: 4.5rem;
		padding: 0;

		img {
			height: inherit;
			margin-left: 1.1rem;
		}
	}
</style>


// WEBPACK FOOTER //
// VisaNet.vue?206812f6